import React from "react";

export const getSeverityBadge = (severity) => {
  const styles = {
    Critical: {
      color: '#dc2626',
      bg: '#fef2f2',
      border: '1px solid #fecaca'
    },
    High: {
      color: '#ea580c',
      bg: '#fff7ed',
      border: '1px solid #fed7aa'
    },
    Medium: {
      color: '#d97706',
      bg: '#fffbeb',
      border: '1px solid #fde68a'
    },
    Low: {
      color: '#16a34a',
      bg: '#f0fdf4',
      border: '1px solid #bbf7d0'
    }
  };

  const style = styles[severity] || { 
    color: '#6b7280', 
    bg: 'rgba(107, 114, 128, 0.1)', 
    border: '1px solid rgba(107, 114, 128, 0.3)' 
  };

  return (
    <span style={{
      display: "inline-block",
      padding: "4px 12px",
      borderRadius: "6px",
      fontSize: "11px",
      fontWeight: "600",
      backgroundColor: style.bg,
      color: style.color,
      border: style.border,
      textTransform: "uppercase",
      letterSpacing: "0.3px"
    }}>
      {severity}
    </span>
  );
};